import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const lowerOrEqualThanTranslateKey = 'validator.lowerOrEqual'

let maximum: string = ''

export const lowerOrEqualThan = (value: number, maxValue: number) => {
  maximum = maxValue.toString()
  return value <= maxValue
}

export const lowerOrEqualThanTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(
      lowerOrEqualThan,
      localeKey || lowerOrEqualThanTranslateKey,
    ),
)
